import { Delivery, Location } from '../../models/Delivery/Delivery';
import { Action } from 'redux';
import {
    DELIVERY_SET_RECIPIENT_ADDRESS,
    DELIVERY_SET_SENDER_ADDRESS,
    DELIVERY_UPDATE_ADDRESSES_SEARCH,
    DELIVERY_UPDATE_DATETIME,
    DELIVERY_UPDATE_REQUEST, GET_CARGO_TYPES_ERROR, GET_CARGO_TYPES_REQUEST, GET_CARGO_TYPES_RESPONSE,
    GET_COURIER_SCHEDULE_ERROR,
    GET_COURIER_SCHEDULE_REQUEST,
    GET_COURIER_SCHEDULE_RESPONSE,

} from '../../actions/Delivery/delivery';
import moment from 'moment';

export interface DeliveryState {
    loading: boolean;
    pickedDate: string;
    pickedSenderAddress: Location;
    pickedRecipientAddress: Location;
    searchResults: Location[];
    delivery: Delivery;
    courierSchedule: Array<[string, string]>;
    loadingCourierSchedule: boolean;
    errorCourierSchedule: any;
    cargoTypes: Array<{id: number, name: string}>;
    loadingCargoTypes: boolean;
    errorCargoTypes: any;
}

const initialState: DeliveryState = {
    loading: false,
    pickedDate: '',
    searchResults: [],
    pickedSenderAddress: {
        address: ''
    },
    pickedRecipientAddress: {
        address: ''
    },
    delivery: {
        sender: {
            name: '',
            phone: '',
            location: {
                address: ''
            }
        },
        recipient: {
            name: '',
            phone: '',
            location: {
                address: ''
            }
        },
        date: '',
        time_range: ['', ''],
    },
    courierSchedule: Array<[string, string]>(),
    loadingCourierSchedule: false,
    errorCourierSchedule: null,
    cargoTypes: [],
    loadingCargoTypes: false,
    errorCargoTypes: null
};

export function deliveryState(state: DeliveryState = initialState, action: Action): DeliveryState {
    switch (action.type) {
        case DELIVERY_UPDATE_REQUEST: {
            return {
                ...state,
                delivery: (action as any).delivery
            };
        }
        case DELIVERY_UPDATE_DATETIME: {
            return {
                ...state,
                pickedDate: (action as any).pickedDate,
                delivery: {
                    ...state.delivery,
                    date: (action as any).pickedDate
                }
            };
        }
        case DELIVERY_UPDATE_ADDRESSES_SEARCH: {
            return {
                ...state,
                searchResults: (action as any).searchResults
            };
        }
        case DELIVERY_SET_SENDER_ADDRESS: {
            const location = (action as any).pickedSenderAddress as Location;
            return {
                ...state,
                pickedSenderAddress: (action as any).pickedSenderAddress,
                delivery: {
                    ...state.delivery,
                    sender: {
                        ...state.delivery.sender,
                        location: {
                            address: location.address,
                            lat: location.lat,
                            lng: location.lng
                        }
                    }
                }
            };
        }
        case DELIVERY_SET_RECIPIENT_ADDRESS: {
            const location = (action as any).pickedRecipientAddress as Location;
            return {
                ...state,
                pickedRecipientAddress: (action as any).pickedRecipientAddress,
                delivery: {
                    ...state.delivery,
                    recipient: {
                        ...state.delivery.recipient,
                        location: {
                            address: location.address,
                            lat: location.lat,
                            lng: location.lng
                        }
                    }
                }
            };
        }
        case GET_COURIER_SCHEDULE_REQUEST: {
            return {
                ...state,
                courierSchedule: initialState.courierSchedule,
                loadingCourierSchedule: true,
                errorCourierSchedule: initialState.errorCourierSchedule
            };
        }
        case GET_COURIER_SCHEDULE_RESPONSE: {
            let courierSchedule = (action as any).response.result;
            courierSchedule = courierSchedule.filter(schedule => moment().add(2, 'hours').diff(moment(state.delivery.date).add(-3, 'hours').set('hours', schedule[1].substr(0, 2)).set('minutes', schedule[1].substr(3, 2))) < 0);
            let delivery = state.delivery;
            delivery.time_range = courierSchedule.length > 0 ? courierSchedule[0] : ['', ''];
            return {
                ...state,
                courierSchedule,
                loadingCourierSchedule: initialState.loadingCourierSchedule,
                delivery
            };
        }
        case GET_COURIER_SCHEDULE_ERROR: {
            const errorCourierSchedule = (action as any).response.error;
            return {
                ...state,
                loadingCourierSchedule: initialState.loadingCourierSchedule,
                errorCourierSchedule
            };
        }
        case GET_CARGO_TYPES_REQUEST: {
            return {
                ...state,
                loadingCargoTypes: true,
                errorCargoTypes: initialState.errorCargoTypes
            };
        }
        case GET_CARGO_TYPES_RESPONSE: {
            const cargoTypes = (action as any).response.result;
            return {
                ...state,
                cargoTypes,
                loadingCargoTypes: initialState.loadingCargoTypes
            };
        }
        case GET_CARGO_TYPES_ERROR: {
            const errorCargoTypes = (action as any).response.error;
            return {
                ...state,
                loadingCargoTypes: initialState.loadingCargoTypes,
                errorCargoTypes
            };
        }
        default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Delivery/delivery.ts